import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import rem from 'polished/lib/helpers/rem';
import spacing from '@decisiv/design-tokens/lib/spacing';
import TextField from '@decisiv/ui-components/lib/components/TextField';

export const WmiCodesSection = styled(Flex)`
  gap: 0.313rem;
  width: 100%;
  background: ${toColorString(color.base.snowWhite)};
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

export const LineDivider = styled.div`
  width: 100%;
  height: ${rem(spacing.base * 0.1)};
  background: ${toColorString(color.opacity.charcoal15)};
`;

export const FilterTextField = styled(TextField)`
  width: 310px;
`;

export const ContentSection = styled(Flex)`
  width: 100%;
  padding: 16px;
  background: ${toColorString(color.base.snowWhite)};
`;
